import { AuthStateModel } from './auth-state';

export enum AimiLocalStorageItem {
  LOGIN_STATUS = 'login_status',
}

export class AuthLogin {
  static readonly type = '@AuthState.login';
}

export class AuthLogOut {
  static readonly type = '@AuthState.logout';
}

export class AuthPatchState {
  static readonly type = '@AuthState.patchState';
  constructor(public payload: Partial<AuthStateModel>) {}
}
